// Apagar dentro do campo (à direita): toque apaga um caractere; segurar 2 s
// apaga tudo. Usado no CPF e no nome do totem.
import { Delete } from "lucide-react";

import Tecla from "./Tecla";

export default function BotaoApagar({ onApagar, onLimpar, desabilitado }) {
  return (
    <Tecla
      onPress={onApagar}
      onHold={onLimpar}
      disabled={desabilitado}
      aria-label="Apagar (segure para apagar tudo)"
      title="Toque: apaga uma letra · Segure: apaga tudo"
      data-e2e="botao-apagar"
      className="absolute right-3 top-3 w-14 h-14 rounded-xl bg-zinc-800 hover:bg-zinc-700 text-zinc-200 flex items-center justify-center disabled:opacity-30"
    >
      <Delete className="w-7 h-7" />
    </Tecla>
  );
}
